var index = 0;
export var getUid = function getUid() {
  return +new Date() + "_" + ++index;
};